import script from "./CollectiviteMembreEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollectiviteMembreEdit.vue?vue&type=script&setup=true&lang=ts"

import "./CollectiviteMembreEdit.vue?vue&type=style&index=0&id=1cb5d270&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cb5d270"]])

export default __exports__